import { commandCenterLoansApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

const TURN_TIME_STAGES_WINDOW_DAYS = 90;

export const COMMAND_CENTER_TURN_TIME_STAGES_ACTION_TYPE = createNamedActions(
  'commandCenterTurnTimeStages',
  {
    SET_TURN_TIME_STAGES: 'SET_TURN_TIME_STAGES',
  },
);

export const getCommandCenterTurnTimeStagesAction = catchAsyncActionError(() => async dispatch => {
  try {
    const { data } = await commandCenterLoansApi.getTurnTimeStages({
      windowDays: TURN_TIME_STAGES_WINDOW_DAYS,
      config: SKIP_FORBIDDEN_CONFIG,
    });

    dispatch({
      type: COMMAND_CENTER_TURN_TIME_STAGES_ACTION_TYPE.SET_TURN_TIME_STAGES,
      payload: data ?? null,
    });
  } finally {
    // In a `finally` so the slice is marked loaded even when a swallowed 403
    // (SKIP_FORBIDDEN_CONFIG) rejects — otherwise the zone skeleton never clears.
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.TURN_TIME_STAGES));
  }
});
